/**
 * @desc 获取全流程可视化地址源 code值说明 C-173-1 全场 | C-173-2 制造分厂 | C-173-3 水泥分厂 | C-173-4 矿山分厂
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** code */
  code?: string;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.VisualResponse>> {
  return defHttp.get({
    url: '/visual',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.VisualResponse>> {
  return defHttp.get({
    url: '/mock/visual',

    params,
  });
}
